/**
 * 全站权限配置
 *
 */
import router from './router/index';
import store from './store'
import {validatenull} from '@/util/validate';
import {getStore,setStore} from "@/util/store.js";

router.beforeEach(function(to, from, next) {
    const value = to.query.src || to.fullPath;
    const label = to.query.name || to.name;
    const meta = to.meta || router.$avueRouter.meta || {};
    const i18n = to.query.i18n;
    if (to.query.target) {
      window.open(value)
    } else if (meta.isTab !== false && !validatenull(value) && !validatenull(label)) {
      store.commit('ADD_TAG', {
        label: label,
        value: value,
        params: to.params,
        query: to.query,
        meta: (() => {
          if (!i18n) {
            return meta
          }
          return {
            i18n: i18n
          }
        })(),
        group: []
      });
    }
    next()
})



// WEBPACK FOOTER //
// ./src/permission.js